import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "../layout/Layout";
import { WelcomePage } from "../pages/WelcomePage";
import { OperationsBoardPage } from "../pages/flameking/OperationsBoardPage";
import { FreightPage } from "../pages/flameking/FreightPage";
import { ProductionPlanPage } from "../pages/flameking/ProductionPlanPage";
import { CalendarPage } from "../pages/flameking/CalendarPage";
import { PeoplePage } from "../pages/flameking/PeoplePage";
import { PersonDetailPage } from "../pages/flameking/PersonDetailPage";
import { VendorsPage } from "../pages/flameking/VendorsPage";
import { VendorDetailPage } from "../pages/flameking/VendorDetailPage";
import { MeetingsPage } from "../pages/MeetingsPage";
import { MeetingDetailPage } from "../pages/MeetingDetailPage";
import { KbPage } from "@/components/kb/KbPage";
import { KbBlueprintPage } from "../blueprint/KbBlueprintPage";
import { KnowledgeBaseListPage } from "../knowledge-base-list/KnowledgeBaseListPage";
import { SkillsPage } from "../skills/SkillsPage";
import { SkillDetailPage } from "../skills/SkillDetailPage";
import { MemoryPage } from "../memory/MemoryPage";

// Boards are heavy (React Flow + large content) and must NOT sit in the main
// bundle — an oversized eager board chunk was interfering with app startup on
// the live domain. Lazy-load them so they only load when their route opens.
const TMBoardPage = lazy(() =>
  import("../board/TMBoardPage").then((m) => ({ default: m.TMBoardPage })),
);
const SkillsBoardPage = lazy(() =>
  import("../board/SkillsBoardPage").then((m) => ({ default: m.SkillsBoardPage })),
);

const boardFallback = (
  <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", color: "#8A8580", fontFamily: "Inter, system-ui, sans-serif" }}>
    Loading board…
  </div>
);

// Top-level app. AuthKitProvider + AuthGate in App.tsx gate this whole tree,
// so every route here assumes an authenticated user.
export const CRM = () => (
  <Layout>
    <Routes>
      <Route path="/" element={<OperationsBoardPage />} />
      <Route path="/operations" element={<OperationsBoardPage />} />
      <Route path="/freight" element={<FreightPage />} />
      <Route path="/production-plan" element={<ProductionPlanPage />} />
      <Route path="/calendar" element={<CalendarPage />} />
      <Route path="/meetings" element={<MeetingsPage />} />
      <Route path="/meetings/:id" element={<MeetingDetailPage />} />
      <Route path="/update-log" element={<KbPage slug="update-log" />} />
      <Route path="/people" element={<PeoplePage />} />
      <Route path="/people/:name" element={<PersonDetailPage />} />
      <Route path="/vendors" element={<VendorsPage />} />
      <Route path="/vendors/:name" element={<VendorDetailPage />} />
      <Route path="/knowledge-base" element={<KnowledgeBaseListPage />} />
      <Route path="/skills" element={<SkillsPage />} />
      <Route path="/skills-board" element={<Suspense fallback={boardFallback}><SkillsBoardPage /></Suspense>} />
      <Route path="/skills/:slug" element={<SkillDetailPage />} />
      <Route path="/memory" element={<MemoryPage />} />
      <Route path="/tm-board" element={<Suspense fallback={boardFallback}><TMBoardPage /></Suspense>} />
      <Route path="/kb-doc/*" element={<KbBlueprintPage />} />
      <Route path="/welcome" element={<WelcomePage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Layout>
);
